import * as React from 'react';

import { AlertBox } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

const ErrorMessage: React.StatelessComponent<{}> = () => (
  <Box justifyContent="center" alignItems="center" display="flex" height={'100vh'}>
    <AlertBox
      type="error"
      heading="Something went wrong"
      message="Sorry, looks like we're having some issues. Go back and try again or come back later."
    />
  </Box>
);

export { ErrorMessage };
